import { jsx as a } from "react/jsx-runtime";
const o = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentcolor",
        d: "M21 6a1 1 0 0 1-.883.993L20 7h-3.171a3.001 3.001 0 0 1-5.658 0H4a1 1 0 0 1-.117-1.993L4 5h7.17a3 3 0 0 1 2.654-1.995L14 3l.176.005A3 3 0 0 1 16.83 5H20a1 1 0 0 1 1 1M21 12a1 1 0 0 1-.883.993L20 13h-9.171a3 3 0 0 1-5.658 0H4a1 1 0 0 1-.117-1.993L4 11h1.17a3 3 0 0 1 2.654-1.995L8 9l.176.005A3 3 0 0 1 10.83 11H20a1 1 0 0 1 1 1M20.747 18.664A1 1 0 0 0 20 17h-.17a3 3 0 0 0-2.654-1.995L17 15l-.176.005A3 3 0 0 0 14.17 17H4l-.117.007A1 1 0 0 0 4 19h10.171a3 3 0 0 0 5.658 0H20l.117-.007a1 1 0 0 0 .63-.329"
      }
    )
  }
);
export {
  o as default
};
